module.exports = __webpack_public_path__ + "static/media/5_Identify-Chime-Type-Digital.72e70f48.svg";